import { render, staticRenderFns } from "./PageProducts.vue?vue&type=template&id=7b4fe87d&"
import script from "./PageProducts.vue?vue&type=script&lang=js&"
export * from "./PageProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports